// extracted by mini-css-extract-plugin
export default {"CompanyName":"HomeComponent_CompanyName__9wUEw"};